import { Link, SpaceBetween } from "@amzn/awsui-components-react";
import ErrorBoundary from "@amzn/awsui-components-react/polaris/error-boundary";
import {
  AccountingEventsGroup,
  DigitalBusinessDocument,
  DigitalCostDocument,
  DigitalPaymentDocument,
} from "../types";
import { useExternalLinks } from "../hooks/useExternalLinks";

interface Props {
  accountingEventsGroup?: AccountingEventsGroup;
  digitalBusinessDocument?: DigitalBusinessDocument;
  digitalCostDocument?: DigitalCostDocument;
  digitalPaymentDocument?: DigitalPaymentDocument;
  cbeIdempotenceId?: string;
}

function ExternalLinksContent(props: Props) {
  const { links } = useExternalLinks(props);

  return (
    <div>
      <SpaceBetween direction="horizontal" size="m">
        {links.map((link) => (
          <Link
            key={link.key}
            external
            externalIconAriaLabel="Opens in a new tab"
            href={link.href}
            data-testid={link.testId}
          >
            {link.text}
          </Link>
        ))}
      </SpaceBetween>
    </div>
  );
}

export default function ExternalLinks(props: Props) {
  return (
    <ErrorBoundary
      errorBoundaryId="external-links"
      i18nStrings={{
        headerText: "Unexpected error, external links failed to display",
        descriptionText: "Refresh the page to try again.",
        refreshActionText: "Refresh page",
      }}
      onError={({ error, errorInfo }) =>
        console.error("Error rendering external links: ", error, errorInfo)
      }
    >
      <ExternalLinksContent {...props} />
    </ErrorBoundary>
  );
}
